import { CherryPayApi } from "../api/models";

class EventUtil {
  static getStatusColorScheme = (status: string) => {
    switch (status.toLowerCase()) {
      case "published":
        return "#189cf5";
      case "draft":
        return "#807d82";
      case "completed":
        return "#5eb964";
      case "canceled":
        return "#d53e46";
      default:
        return "gray";
    }
  };

  static getEventScanUrl = (event: CherryPayApi.Event): string => {
    return `${ODMA_BASE_URL}events/${event.id}?businessId=${event.BusinessId}`;
  };
}

export default EventUtil;
